import { BoltIcon } from '@heroicons/react/20/solid';
import { CondenserProductType, SystemOptionCondenserType } from 'data/types';
import { ptacElectricalLabel } from 'utils/ptac-electrical-label';
import { PTAC_UNIT_SWAP_TOOLTIP } from 'utils/ptac-unit-swap';
import { CondenserHeader } from './condenser-component-rows';
import SwapProductPopover from './swap-product-popover';

type PtacUnitComponentGroupProps = Readonly<{
  condenser: SystemOptionCondenserType;
  alternatives: CondenserProductType[];
  isLoading: boolean;
  onSwap?: (productId: number) => void;
}>;

export default function PtacUnitComponentGroup({
  condenser,
  alternatives,
  isLoading,
  onSwap
}: PtacUnitComponentGroupProps) {
  if (!condenser.selectedProduct) {
    return null;
  }

  return (
    <div className='overflow-hidden rounded-lg border border-gray-200'>
      <CondenserHeader
        condenser={condenser}
        zoneCount={condenser.zones.length}
        actions={
          onSwap && (
            <SwapProductPopover
              variant='ptacUnit'
              products={alternatives}
              currentProduct={condenser.selectedProduct}
              onSelect={onSwap}
              hasActiveLocks={false}
              tooltipText={PTAC_UNIT_SWAP_TOOLTIP}
              isLoading={isLoading}
            />
          )
        }
      />
      <div
        data-testid='ptac-unit-electrical'
        className='flex items-center gap-1.5 px-4 py-2 text-xs text-gray-600'
      >
        <BoltIcon className='h-4 w-4 text-amber-500' />
        <span>{ptacElectricalLabel(condenser.selectedProduct)}</span>
      </div>
    </div>
  );
}
